<template v-slot="{ open, close, opened, toggle }">
  <div class="flex between">
    <vf-link
      v-if="!content.hideShopAll?.lg"
      class="flex"
      :class="[classLink, brandClasses.shopAll]"
      :target="content.target?.targetAttribute"
      :to="content.target?.url"
      variant="quieter"
      @click="$emit('click')"
    >
      {{ content.overrideShopAll || `${$t.megaMenuShopAll} ${content.title}` }}
      <vf-icon :name="linkIcon" size="md" />
    </vf-link>
    <base-button v-if="showClose" :aria-label="$t.close" class="ml-a" @click="forceClose">
      <vf-icon name="close" :size="closeIconSize" />
    </base-button>
  </div>
</template>

<script setup lang="ts">
import type { CSSClass } from '#types/common'
import type { MenuItem } from '#types/components/cms/mega-menu'
import { PopoverContextKey } from '#core/components/base/popover/context'

defineProps<{
  classLink?: CSSClass
  content: MenuItem
  showClose?: boolean
}>()

defineEmits<{
  click: []
}>()

const {
  megaMenu: { closeIconSize, linkIcon },
  megaMenuL1Desktop: { brandClasses }
} = useAppConfig().components.cms

const { forceClose } = inject(PopoverContextKey)!
</script>
